import { useSelector } from 'react-redux'
import { getSavedActiveProjects } from '../components/shared/utils'

export const useSavedActiveProjects = () => useSelector(getSavedActiveProjects)
